import fecha from 'fecha';
import {observer} from 'mobx-react';
// import UI from '../stores/UI';
import HELP from '../stores/Help';
import CONTENT from '../stores/Content';
import Markdown from '../components/Markdown';
import Sheet from '../components/Sheet';

const FormatDate = ({datetime, format}) => {
  return (
    <span>{fecha.format(new Date(datetime), format)}</span>
  )
}

const Caret = ({open}) => (
  <span className="caret" style={{
    transform: open ? `rotate(0deg)` : `rotate(-90deg)`
  }}>
    <svg width="21px" height="12px" viewBox="0 0 21 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <polygon fill="#1C1D21" fillRule="nonzero" points="19.8643613 0 20.5714681 0.707106781 10.0936916 11.1848832 0 1.09119156 0.707106781 0.384084784 10.0936916 9.77066964"></polygon>
    </svg>
  </span>
)

class Event extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      open: false
    }
  }

  componentDidMount() {
    const slug = this.props.match.params.slug;

    if (slug) {
      if (slug === this.props.slug) {
        this.setState({
          open: true
        })
      }
    } else {
      if (this.props.open) {
        this.setState({
          open: true
        })
      }
    }
  }

  handleClick = e => {
    e.stopPropagation()
    this.setState((prevState) => {
      if (!prevState.open) {
        history.pushState(null, '', `/events/${this.props.slug}`)
      }
      return {
        open: prevState.open ? false : true
      }
    })
  }

  render() {
    return (
      <div className="event max middle outerx2 guttersx2" style={{
        opacity: this.state.open ? 1 : this.props.past ? 0.5 : 1
      }}>
        <div className="guttersx2 pointer" onClick={this.handleClick}>
          <hr className="bdr-top" />
          <div className="spaced">
            <span className="p2">
              <Caret open={this.state.open} />
              <span>{this.props.title}</span>
              {this.props.past ? (
                <span className="h5">{" (Archive)"}</span>
              ) : null}
            </span>
            <span className="p2">
              {this.props.start ? (
                <span>
                  <FormatDate datetime={this.props.start} format={'D MMM'} />
                  <span>—</span>
                </span>
              ) : null}
              <FormatDate datetime={this.props.end} format={'D MMM YYYY'} />
            </span>
          </div>
        </div>
        {this.state.open ? (
          <div className="event-info innerx4">
            <Markdown className="guttersx2" convert={this.props.article} />
            <div className="cols innerx4">
              <Markdown className="details h5 guttersx2" convert={this.props.details} />
              <Markdown className="details h5 guttersx2" convert={this.props.address} />
              <span className="details h5 guttersx2">
                {this.props.ticketsUrl ? <a href={HELP.convertLink(this.props.ticketsUrl).url} className="btn mb" target="_blank">{HELP.convertLink(this.props.ticketsUrl).text}</a> : null}
                {this.props.facebookEventUrl ? <a href={HELP.convertLink(this.props.facebookEventUrl).url} className="btn mb" target="_blank">{HELP.convertLink(this.props.facebookEventUrl).text}</a> : null}
              </span>
            </div>
            {this.props.artwork ? (
              <div className="guttersx2 markdown">
                <blockquote>
                  <p>
                    <img src={HELP.getMedia(this.props.artwork).src} />
                  </p>
                  <h5>{this.props.artwork.fields.description}</h5>
                </blockquote>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    )
  }
}

const Events = ({match}) => {
  return (
    <Sheet order={2} className="bg-sky">
      {CONTENT.events ? (
        <div className="innerx8">
          {CONTENT.events.map(({fields}, i) => (
            <Event {...fields} match={match} open={i < 1} key={`event-${i}`} />
          ))}
          <div className="past-events">
            {CONTENT.pastEvents.map(({fields}, i) => (
              <Event {...fields} match={match} past={true} key={`past-event-${i}`} />
            ))}
          </div>
        </div>
      ) : (
        <h5 className="txt-c innerx8">Loading...</h5>
      )}
    </Sheet>
  )
}

export default observer(Events)



// WEBPACK FOOTER //
// ./app/javascript/packs/pages/Events.js